import { createContext, Dispatch, SetStateAction, useContext } from 'react'

type ProgramContextInitialValue = {
  filterValue: string
  setFilterValue: Dispatch<SetStateAction<string>>
}

export const ProgramContext = createContext<ProgramContextInitialValue>({
  filterValue: '',
  setFilterValue: () => {},
})

export const useProgramContext = () => useContext(ProgramContext)
